module.exports = __webpack_public_path__ + "assets/d5ed1943a9190e8ed7f11d79b2d2923a.mp4";